import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';

export const Link = styled(RouterLink)(({ theme }) => ({
  marginLeft: 2,
  fontSize: '0.875rem',
  lineHeight: '1.125rem',
  fontWeight: 500,
  color: theme.palette.primary.main,
  textDecoration: 'none',
}));
